<mat-form-field class="search" floatLabel="never">
  <input
    placeholder="Search"
    matInput
    autofocus
    [(ngModel)]="search"
    (ngModelChange)="onSearchChange()"
    (click)="$event.stopPropagation()"
  />
</mat-form-field>

<div class="options-container">
  <ng-template [ngIf]="!isLoading && options">
    <mat-list>
      <div class="option-list">
        <mat-list-item class="option mat-option" *ngFor="let option of options; trackBy: trackTag">
          <mat-checkbox
            [checked]="selection.isSelected(option)"
            (click)="$event.stopPropagation()"
            (change)="selection.toggle(option)"
          >
          </mat-checkbox>
          {{ option.name }}
        </mat-list-item>
        <mat-list-item
          class="option mat-option"
          *ngIf="!options.length && search"
          (click)="selectTag()"
        >
          {{ search }}
          <br />
          <small>(create tag)</small>
        </mat-list-item>
      </div>
      <div *ngIf="selection.dirty" [@snFadeInUp]>
        <mat-divider></mat-divider>
        <mat-list-item class="addBtn option action mat-option" (click)="acceptTags()">
          <span matLine>Add Tags</span>
        </mat-list-item>
      </div>
    </mat-list>
  </ng-template>

  <ng-template [ngIf]="isLoading">
    <mat-progress-bar
      class="progress-loader"
      [color]="'accent'"
      [mode]="'indeterminate'"
    ></mat-progress-bar>
  </ng-template>
</div>
